export function successClose() {
    $(".close-success").on("click", function () {
        $(this).parents(".submit-form-success").fadeOut(200);
        $(this).parents(".submit-form").removeClass("hidden");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/successClose.js